var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { List } from "@react-md/list";
import { Menu } from "./Menu";
/**
 * The default menu renderer that will just render the `Menu` component along
 * with a `List` by passing all props down to the main `Menu` component.
 */
export function defaultMenuRenderer(_a) {
    var horizontal = _a.horizontal, children = _a.children, props = __rest(_a, ["horizontal", "children"]);
    return (React.createElement(Menu, __assign({}, props, { horizontal: horizontal }),
        React.createElement(List, { horizontal: horizontal }, children)));
}
//# sourceMappingURL=defaultMenuRenderer.js.map